import React from 'react';

/**
 * I-P0-B: server-derived session integrity status (NONE / MEDIUM / HIGH).
 * It summarises UNREVIEWED automated signals. It is not a score, not a verdict and is
 * independent of the candidate's capability scores.
 */
const STATUS = {
  NONE:   { label: 'No review signals',       cls: 'bg-emerald-900/30 text-emerald-300 border-emerald-700',
            light: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  MEDIUM: { label: 'Review signals (medium)', cls: 'bg-amber-900/30 text-amber-300 border-amber-700',
            light: 'bg-amber-50 text-amber-700 border-amber-200' },
  HIGH:   { label: 'Review signals (high)',   cls: 'bg-orange-900/40 text-orange-200 border-orange-600',
            light: 'bg-orange-50 text-orange-700 border-orange-200' },
};

export function IntegrityStatusBadge({ status, compact = false, light = false }) {
  const s = STATUS[(status || '').toUpperCase()];
  if (!s) {
    return <span className="text-xs text-slate-500">Not evaluated</span>;
  }
  return (
    <span className="inline-flex flex-col gap-0.5">
      <span className={`inline-flex w-fit px-2 py-0.5 rounded text-[11px] font-semibold border ${light ? s.light : s.cls}`}>
        {s.label}
      </span>
      {!compact && (
        <span className="text-[9px] text-slate-500">Unreviewed signals, not a verdict</span>
      )}
    </span>
  );
}

export default IntegrityStatusBadge;
